// Request a Topic field limits -- MIRRORED from backend/core/topic_requests.py (the
// server is the authority and re-validates everything). Keep the numbers in step.
export const TOPIC_TITLE_MIN = 5;
export const TOPIC_TITLE_MAX = 150;
export const TOPIC_DESCRIPTION_MIN = 20;
export const TOPIC_DESCRIPTION_MAX = 2000;

export const TOPIC_CATEGORIES = ['Article', 'Tool', 'Simulation'];

// Matches the backend's title normalisation (strip + collapse whitespace runs), so the
// length the user sees counted is the length the server checks.
const normaliseTitle = (value) => (value || '').split(/\s+/).filter(Boolean).join(' ');

const lengthError = (len, field, min, max) => {
  if (len === 0) return `${field} is required`;
  if (len < min) return `${field} must be at least ${min} characters`;
  if (len > max) return `${field} must be at most ${max} characters`;
  return null;
};

export const titleLength = (title) => normaliseTitle(title).length;
export const descriptionLength = (description) => (description || '').trim().length;

export const validateTopicRequest = ({ title, category, description }) => {
  const errors = {};
  const t = lengthError(titleLength(title), 'Topic title', TOPIC_TITLE_MIN, TOPIC_TITLE_MAX);
  const d = lengthError(descriptionLength(description), 'Description', TOPIC_DESCRIPTION_MIN, TOPIC_DESCRIPTION_MAX);
  if (t) errors.title = t;
  if (!TOPIC_CATEGORIES.includes(category)) errors.category = 'Please select a category';
  if (d) errors.description = d;
  return errors;
};

export const topicRequestErrorMessage = (err) => {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (d.msg || '').replace(/^Value error, /, '')).filter(Boolean).join('; ')
      || 'Please check the form and try again.';
  }
  if (status === 429 && !detail) return 'You are doing that too often. Please wait a while and try again.';
  if (typeof detail === 'string' && detail) return detail;
  if (!err?.response) return 'Could not reach the server. Check your connection and try again.';
  return 'Failed to submit your request. Please try again.';
};
